import { RootState } from '@next/core-lib/app';
import { EntityState } from '@ngrx/entity';

import { LeeOAuthentication, NedapInstallation } from './third-parties.model';

export interface SettingModuleState extends RootState {
  barns: BarnState;
  selectedBarn: Barn;
  silos: Silo[];
  energySystem: EnergySystem;
  lysineSystem: LysineSystem;
  discount: Discount;
  isLoaded: boolean;
  dosatorSettings: DosatorSettingState;
  selectedDosatorSetting: DosatorSetting;
  nedapInstallations: NedapInstallation[];
  leeOAuthentication: LeeOAuthentication;
}
export type BarnState = EntityState<Barn>;
export type DosatorSettingState = EntityState<DosatorSetting>;

export enum EnergySystem {
  EW = 'EW',
  MEMJ = 'MEMJ',
  MEkcal = 'MEkcal',
  NEMJ = 'NEMJ',
  NEkcal = 'NEkcal',
}
export enum LysineSystem {
  AID = 'AID',
  SID = 'SID',
}

export interface Barn {
  id?: number;
  name: string;
  surfaceArea: number;
  properties: BarnProperties;
}

export interface BarnProperties {
  sections?: string[];
  silo?: Silo[];
}

export interface GetBarnsResponse {
  barns: Barn[];
}

export interface UpsertBarnResponse {
  id: number;
}

export interface Silo {
  id: number;
  shipToId: number;
  customerId: number;
  siloNumber: string;
  name: string;
}

export interface GetSilosResponse {
  silos: Silo[];
}

export interface Discount {
  bulkDiscountPer100Kg?: number;
  purchaseDiscountPer100Kg?: number;
  deliveryDayDiscountPer100Kg?: number;
  paymentDiscountPercentage?: number;
  memberBenefitDiscountPercentage?: number;
  memberDiscountPer100Kg?: number;
  currency?: string;
}

export interface UpsertDiscountResponse {
  id: number;
}

export interface DosatorSetting {
  id?: number;
  name: string;
  products: DosatorProduct[];
}

export interface DosatorProduct {
  productId: number;
  conversions: DosatorConversions[];
}

export interface DosatorConversions {
  liter: number;
  kilogram: number;
  kilogramPerLiter: number;
}

export interface DosatorConversionTableScheme {
  dosatorConversionsLines: DosatorConversions[];
}

export interface GetDosatorSettingsResponse {
  dosatorSettings: DosatorSetting[];
}

export interface UpsertDosatorSettingResponse {
  id: number;
}
